import graphql__722c8dd797b85177bab5 from "./__generated__/Sitemap_sitemapRoots.graphql.js";
import graphql__ea15c2e6f2ede61dbd82 from "./__generated__/Sitemap_node.graphql.js";
import graphql__4668d1fe767cd0464089 from "./__generated__/Sitemap_nestedSitemapNode.graphql.js";import { useFragment, graphql } from "react-relay";
import { defineMessages } from "react-intl";

import Search from "../Filters/Search";
import SitemapItem from "./SitemapItem";
import { useFormatMessage } from "../Intl/Context";
import { useResourcesList } from "../ResourcesList/resourcesList";
import { filterMatchingNodes } from "../Utils/filterMatchingNodes";

const Sitemap = props => {
  const sitemapRoots = useFragment(Sitemap_sitemapRoots, props.sitemapRoots);

  const t = useFormatMessage();
  const srDescription = t(intlMessages.srDescription);

  const resourcesList = useResourcesList();
  const searchTerms = resourcesList.search?.terms;

  const rootItems = filterMatchingNodes(sitemapRoots, searchTerms);

  return (
    <>
      <div className="p-3 box-shadow-filters position-sticky">
        <Search enableLabel srDescription={srDescription} disableThrottling />
      </div>

      <div>
        <ul className="sitemap-list-container">
          {rootItems.map((node, index) => (
            <SitemapItem key={index} node={node} />
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sitemap;

const Sitemap_sitemapRoots = graphql__722c8dd797b85177bab5;

graphql__ea15c2e6f2ede61dbd82;

graphql__4668d1fe767cd0464089;

export const intlMessages = defineMessages({
  srDescription: {
    id: "sitemap.srDescription",
    defaultMessage:
      "dans le plan du site (mise à jour de ce dernier au fur et à mesure de votre saisie)"
  }
});
